import { createGlobalStyle } from "styled-components";

import TitilliumWebBold from "./TitilliumWeb-Bold.ttf";
import TitilliumWebRegular from "./TitilliumWeb-Regular.ttf";
import TitilliumWebSemiBold from "./TitilliumWeb-SemiBold.ttf";
import TitilliumWebLight from "./TitilliumWeb-Light.ttf";

export default createGlobalStyle`
  @font-face {
    font-family: 'Titillium Web';
    src: url(${TitilliumWebLight}) format('truetype');
    font-weight: light;
  }
  @font-face {
    font-family: 'Titillium Web';
    src: url(${TitilliumWebRegular}) format('truetype');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Titillium Web';
    src: url(${TitilliumWebSemiBold}) format('truetype');
    font-weight: 600;
  }
  @font-face {
    font-family: 'Titillium Web';
    src: url(${TitilliumWebBold}) format('truetype');
    font-weight: bold;
  }
  * {
    font-family: 'Titillium Web', sans-serif;
  }
`;
